/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { ETransportUniqueResource } from './etransport-unique-resource';

export class ETransportPackageDTO extends ETransportUniqueResource {
  uuid: string | null = null;
  packageUuids: string[] = [];
  // tariffCodeUuid: string | null = null;
  tariffCode: string | null = null;
  cargoName: string | null = null;
  operationPurposeUuid: string | null = null;
  quantity: number | null = null;
  unitMeasurementUuid: string | null = null;
  netWeight: number | null = null;
  grossWeight: number | null = null;
  valueWithoutVAT: number | null = null;
  unitPrice: number | null = null;
  refDeclarant: string | null = null;
  customLabel ?: string;

  static isPackageEmpty(aPackage: ETransportPackageDTO): boolean {
    const isStrEmpty = (v: string | null | undefined) =>
      v == null || v.trim() === '';

    const isNumEmpty = (v: number | null | undefined) =>
      v == null;

    const isArrEmpty = (v: any[] | null | undefined) =>
      !v || v.length === 0;

    return (
      isStrEmpty(aPackage.uuid) &&
      isArrEmpty(aPackage.packageUuids) &&
      isStrEmpty(aPackage.tariffCode) &&
      isStrEmpty(aPackage.cargoName) &&
      isStrEmpty(aPackage.operationPurposeUuid) &&
      isNumEmpty(aPackage.quantity) &&
      isStrEmpty(aPackage.unitMeasurementUuid) &&
      isNumEmpty(aPackage.netWeight) &&
      isNumEmpty(aPackage.grossWeight) &&
      isNumEmpty(aPackage.valueWithoutVAT) &&
      isNumEmpty(aPackage.unitPrice) &&
      isStrEmpty(aPackage.refDeclarant) &&
      isStrEmpty(aPackage.customLabel)
    );
  }
}

